module.exports = __webpack_public_path__ + "img/driver-bot-avatar-72.9665cb71.png";